// extracted by mini-css-extract-plugin
export var contentContainer = "contentPage-module--contentContainer--OjQxH";